/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/js/anniversary/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	// var login =require('./login.js');
	var form = __webpack_require__(4);
	// var Modal = require('@pangu/modal');
	// var modal = new Modal('.js-modal');
	var res = $.extend({}, response);
	var Slide = __webpack_require__(3);
	var videoPlayer = __webpack_require__(5);
	var $video = $('.js-jnh-video');
	
	videoPlayer.init($video, $video.data('src'), $video.data('poster'));
	
	// 报名
	// $('.js-open-apply').click(function () {
	//     if (!res.logined) {
	//         login.open();
	//         return;
	//     }
	
	//     if (!form.applyed) {
	//         form.reset();
	//     }
	//     modal.open();
	// });
	
	// 底部切换
	new Slide($('.js-gallery').children(), {
	    duration: 2500
	});
	
	// 直播
	// var $player = $('.js-live-player');
	// var $tabs = $('.js-live-tab a');
	// var players = {
	//     cc: { type: 'flash', data: 'http://res.cc.netease.com/webcc/weblbs/htdocs/webcc/stoneSwf/ClientLoader.swf?roomId=1314&subId=3478054&ch_type=ty&useBlank=1&play_mode=1&config=List&showGetInRoomLayer=1&useChat=1&showChat=0&joinRoomConnetServer=1&webccType=4082&updateBarrage=1&playerParam=nomask,1;src,ty' },
	//     douyu: { type: 'embed', data: '<embed width="100%" height="100%" allownetworking="all" allowscriptaccess="always" src="https://staticlive.douyucdn.cn/common/share/play.swf?room_id=2314536" quality="high" bgcolor="#000" wmode="window" allowfullscreen="true" allowFullScreenInteractive="true" type="application/x-shockwave-flash">' },
	//     panda: { type: 'flash', data: 'http://s6.pdim.gs/static/84b032315f9e6373.swf?videoId=ffd3d345f7d7a4f4957eb8c63442727c&roomId=1148171' },
	//     bilibili: { type: 'flash', data: 'http://static.hdslb.com/live-static/swf/LivePlayerEx_1.swf?_=1-1-c5a315d&cid=941004&rnd=1497595869&type=1&onready=flash_on_ready_callback&initTime=1497595779068&changeMode=false' }
	// };
	
	// $tabs.click(function () {
	//     var index = $tabs.index(this);
	//     var name = $(this).data('name');
	//     var player = players[name];
	
	//     $tabs.removeClass('active').eq(index).addClass('active');
	
	//     switch (player.type) {
	//     case 'flash':
	//         $player.flash({
	//             swf: player.data,
	//             height: "100%",
	//             width: "100%",
	//             allowFullScreen: true,
	//             wmode: 'opaque',
	//             allowScriptAccess:'always',
	//             base:'.',
	//             quality:"high" ,
	//             bgcolor:"#ffffff"
	//         });
	//         break;
	//     default:
	//         $player.html(player.data);
	//         break;
	//     }
	// });
	
	// $tabs.eq(0).click();


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	window.getAbsoluteUrl = (function() {
	    var a;
	
	    return function(url) {
	        if(!a) a = document.createElement('a');
	        a.href = url;
	
	        return a.href;
	    };
	})();
	
	var obj = {
	    title: "《天谕》生日快乐！",
	    desc: "欢迎您来到《天谕》周年庆典的现场，游园赢取限量道具周边，同贺天谕周年生日！",
	    pic: getAbsoluteUrl(__webpack_require__(2)),
	    url: window.location.href
	};
	
	var weiboobj = {
	    title: obj.title,
	    desc: encodeURIComponent(obj.desc),
	    pic: encodeURIComponent(obj.pic),
	    url: encodeURIComponent(obj.url)
	};
	
	
	$('.share-btn').click(function (event) {
	    var id = $(this).data("id");
	    switch (id) {
	        case "yx":
	            snsShare.init(obj);
	            snsShare.toYixin();
	            break;
	        case "xl":
	            snsShare.init(weiboobj);
	            snsShare.toSinaWeibo();
	            break;
	        case "wx":
	            snsShare.init(obj);
	            var url="http://res.nie.netease.com/comm/js/nie/util/share/api/index.html?url="+window.location.href;
	            window.open(url,'','width='+640+',height='+480);
	            break;
	    }
	});
	
	$(".f-share-icon").hover(
	    function(){
	        $(".f-share-icon").addClass("active");
	    },
	    function(){
	        $(".f-share-icon").removeClass("active");
	    }
	);

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c349a51068148206d7ce7be9ea688d4b.jpg";

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	function Slide ($items, opts) {
	    opts = opts || {};
	
	    this.timer = 0;
	    this.index = 0;
	    this.$items = $items;
	    this.duration = opts.duration || 3000;
	    this.onChange = opts.onChange || $.noop;
	    this.change(0);
	}
	
	Slide.prototype = {
	    contructor: Slide,
	
	    interval: function interval () {
	        var _this = this;
	
	        this.timer = setTimeout(function () {
	            _this._change(++_this.index);
	            interval.call(_this);
	        }, _this.duration);
	    },
	
	    _change: function (type) {
	        if (typeof type === 'string') {
	            type === 'last' ? this.index-- : this.index++;
	        } else {
	            this.index = type;
	        }
	
	        if (this.index < 0) {
	            this.index = this.$items.length - 1;
	        } else if (this.index > this.$items.length - 1) {
	            this.index = 0;
	        }
	
	        this.$items.stop().fadeOut().eq(this.index).fadeIn();
	        this.onChange(this.index);
	    },
	
	    change: function (type) {
	        clearTimeout(this.timer);
	        this._change(type);
	        this.interval();
	    }
	};
	
	module.exports = Slide;


/***/ }),
/* 4 */
/***/ (function(module, exports) {

	var $selectType = $('.js-select-type');
	var $formWrap = $('.js-form-wrap');
	var $applySuccess = $('.js-apply-success');
	var $form = $('.js-form');
	var applying = false;
	var applyTypeMap = { // 1=单人报名；2=结契报名；3=619生日报名
	    single: 1,
	    jieqi: 2,
	    birthday: 3
	};
	var applyType = '';
	var status = '';
	
	var applyObj = {
	    applyed: !!response.applyed,
	};
	
	if (applyObj.applyed) {
	    status = 'success';
	    render();
	}
	
	// 报名表单提交
	$form.on('submit', function (e) {
	    e.preventDefault();
	
	    if (applying) {
	        return;
	    }
	
	    var data = validData($form);
	
	    if (data.error) {
	        return;
	    }
	
	    applying = true;
	
	    $.ajax({
	        url: '/anniversary/apply.json',
	        data: data,
	        method: 'POST'
	    })
	    .success(function (res) {
	        if (res.resCode === 0) {
	            status = 'success';
	            render();
	            applyObj.applyed = true;
	        } else {
	            alert('报名失败，错误码：' + res.resCode);
	        }
	        applying = false;
	    })
	    .fail(function () {
	        applying = false;
	    });
	});
	
	// 选择报名类型
	$selectType.on('click', 'a', function () {
	    var type = $(this).data('type');
	
	    status = 'apply';
	    render();
	    $formWrap.find('[data-type]').hide().filter('[data-type=' + type + ']').show();
	    applyType = applyTypeMap[type];
	});
	
	function render () {
	    switch (status) {
	        case 'select':
	            $selectType.show();
	            $formWrap.hide();
	            $applySuccess.hide();
	            break;
	        case 'apply':
	            $selectType.hide();
	            $formWrap.show();
	            $applySuccess.hide();
	            break;
	        case 'success':
	            $selectType.hide();
	            $formWrap.hide();
	            $applySuccess.show();
	            break;
	    }
	}
	
	function showError (name, data) {
	    $form.find('[name="' + name + '"]').closest('div').addClass('error');
	    data && (data.error = true);
	}
	
	function resetForm () {
	    $form.find('input, select').closest('div').removeClass('error');
	    $form.find('input:not([type=radio]), select').val('');
	}
	
	$form.on('focus click', 'input, select', function () {
	    $(this).closest('div').removeClass('error');
	});
	
	// 验证数据，在没有错误情况下，返回数据
	function validData () {
	    var data = {};
	
	    $form.find('input, select').closest('div').removeClass('error');
	    $form.find('.js-form-group:visible').find('input[name], select[name]').each(function (i, input) {
	        var value = '';
	        
	        switch (input.type) {
	            case 'radio':
	                var $radios = $form.find('input[name=' + input.name + ']');
	                data[input.name] = $radios.filter(':checked').val();
	                break;
	            default:
	                data[input.name] = $.trim(input.value);
	                break;
	        }
	
	        value = data[input.name];
	
	        switch (input.name) {
	            case 'realName':
	                if (!value || !value.match(/^[\u4e00-\u9fa5]{1,4}$/)) { showError(input.name, data); }
	                break;
	            case 'phone':
	                if (!value || !value.match(/^\d{11}$/)) { showError(input.name, data); }
	                break;
	            case 'gender':
	                if (!value) { showError(input.name, data); }
	                break;
	            case 'roleInfo':
	                if (!value) { showError(input.name, data); }
	                break;
	            case 'city':
	                if (!value) { showError(input.name, data); }
	                break;
	            case 'jieqiRoleName':
	                if (!value) { showError(input.name, data); }
	                break;
	        }
	    });
	
	    data.applyType = applyType;
	
	    return data;
	}
	
	applyObj.reset = function () {
	    status = 'select';
	    render();
	    resetForm();
	};
	
	// 重置form
	module.exports = applyObj;


/***/ }),
/* 5 */
/***/ (function(module, exports) {

	exports.init = function ($body, src, poster) {
	    if($.flash.available){
	        $body.flash({
	            swf: "https://tianyu.res.netease.com/gw/14v4/player/player.swf",
	            width: "100%",
	            height: "100%",
	            wmode: 'transparent',
	            allowscriptaccess:"always",
	            allowFullScreen:"true",
	            flashvars:{
	                v1: src,
	                v2: src
	            }
	        });
	    }
	
	    // 360 ie9兼容模式下，flash播放器无法播放，也使用video播放视频
	    if(navigator.userAgent.indexOf('compatible; MSIE 9.0;') > -1 || !$.flash.available){
	        $body.html(
	            '<video width="100%" height="100%" controls="controls" autoplay=true style="background-color: #000;" poster="' + poster + '">' +
	                '<source src="' + src + '" type="video/mp4">' +
	            '</video>'
	        );
	    }
	}


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// jnh.js